const triggerBrowserDownload = (url, fileName = null, target = null) => {
  /**
   * Trigger browser download file from url
   *
   * @param {string} url - Source url
   * @param {string} [fileName] - Optionnal filename override
   * @return {undefined}
   */
  const tempLinkTag = document.createElement("a");
  document.body.appendChild(tempLinkTag);
  tempLinkTag.style = "display: none";
  if (fileName) {
    tempLinkTag.download = fileName;
  }
  tempLinkTag.href = url;
  tempLinkTag.target = target;
  tempLinkTag.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(tempLinkTag);
};

export { triggerBrowserDownload };
